"use client";

import dynamic from "next/dynamic";

const DebugToolbar = dynamic(() => import("@ala/core/debug").then((mod) => mod.DebugToolbar), { ssr: false });

export const LazyDebugToolbar = () => {
  return <DebugToolbar />;
};
